<div class="record-per-page-filter-wrapper">
  <div class="record-per-page-filter-label lbl">
    <p data-cy="record-per-page-filter-label" id="showNumberOfRows">Show number of rows</p>
  </div>
  <div class="record-per-page-filter-dropdown">
    <mat-select data-cy="select-records-per-page" [(ngModel)]="recordsPerPage" (ngModelChange)="valueChange($event)" tabindex="0" role="button" (keyup.enter)="$event.target.click()" aria-labelledby="showNumberOfRows">
      @for (option of recordsPerPageOptions; track option) {
        <mat-option data-cy="records-value-opt" id="records-value-{{ option }}" [value]="option">{{ option }}</mat-option>
      }
    </mat-select>
  </div>
</div>
